/* ============================================================================
   Dashboard layout persistence (mock backend for now)

   Keyed by a storage key so multiple dashboards persist independently.
   Swap loadLayout/saveLayout for API calls later:
     loadLayout(key) -> GET  /dashboard/layout?key=<key>
     saveLayout(key) -> PUT  /dashboard/layout
   ========================================================================== */

export function loadLayout(storageKey: string, fallback: string[]): string[] {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return [...fallback];
    const parsed = JSON.parse(raw) as string[];
    return Array.isArray(parsed) ? parsed : [...fallback];
  } catch {
    return [...fallback];
  }
}

export function saveLayout(storageKey: string, ids: string[]): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify(ids));
  } catch {
    /* storage unavailable - ignore */
  }
}
